<template>
  <frame-visual :id="id" :initVisualMode="initVisualMode"></frame-visual>
</template>

<script>
import FrameVisual from './frames/frame-visual.vue'

export default {
  data: function () {
    const { id, initVisualMode = 'watch' } = this.$route.params
    return {
      id,
      initVisualMode
    }
  },
  components: {
    FrameVisual
  }
}
</script>
